import * as WebBrowser from 'expo-web-browser';
import React from 'react';

import { Text } from '~/components/text';

/**
 * Opens a URL in the browser
 */
export const openUrl = async (url: string): Promise<void> => {
    await WebBrowser.openBrowserAsync(url);
};

/**
 * Returns a component that renders a text with an underline style for use in formatMessage
 */
export const renderUnderlinedText = (value: string): React.JSX.Element => {
    return React.createElement(Text.BUTTON_LABEL, { style: { textDecorationLine: 'underline' } }, value);
};

/**
 * Returns a component that renders a link for use in FormattedMessage
 */
export const renderLink =
    (onPress: () => void) =>
    (value: string): React.JSX.Element => {
        return React.createElement(
            Text.SMALL_BUTTON_LABEL,
            { style: { textDecorationLine: 'underline' }, onPress },
            value
        );
    };

/**
 * The URL for the cancellation terms
 */
export const CANCELLATION_TERMS_URL =
    'https://heltti.fi/wp-content/uploads/2025/03/myheltti-palvelun-yleiset-kayttoehdot-2025.pdf';
